export default __webpack_public_path__ + "static/media/pin-float.43aaf44a.webp";